<template>
  <div class="full-screen-background">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-list class="text-center listOpacity">
            <v-subheader>PathNotes</v-subheader>
  
            <v-list-item
              v-for="note in pathNotes"
              :key="note.id"
            >
              <v-list-item-content>
                <v-list-item-title>{{ note.title }}</v-list-item-title>
                <v-list-item-subtitle>
                  Atualizado em {{ formatDate(note.updatedAt) }} – Tipo: {{ note.updateType }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
  
            <v-list-item v-if="!pathNotes.length">
              <v-list-item-content>
                <v-list-item-title>Nenhum pathnote disponível.</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    </div>
  </template>
  
  <script>
  export default {
    name: "PathNotesList",
    props: {
      /**
       * pathNotes deve ser um array de objetos:
       * [{ id: String|Number, title: String, updatedAt: Date|String, updateType: String }]
       */
      pathNotes: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      formatDate(date) {
        // Formata data no padrão pt-BR. Ajuste se usar Moment ou Day.js
        return new Date(date).toLocaleDateString('pt-BR');
      }
    }
  };
  </script>
  
  <style scoped>
  .v-list-item {
    margin-bottom: 8px;
  }
.listOpacity{
  /* uma sobreposição branca meio translúcida */
  background-color: rgba(107, 104, 104, 0.301);
  padding: 1rem;          /* opcional, para dar espaçamento interno */
  border-radius: 0.5rem;  /* opcional, só pra ficar mais bonito */
}
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
  </style>
  